import { render, staticRenderFns } from "./setting-pay-pwd.vue?vue&type=template&id=5533ba13&scoped=true&"
import script from "./setting-pay-pwd.vue?vue&type=script&lang=js&"
export * from "./setting-pay-pwd.vue?vue&type=script&lang=js&"
import style0 from "./setting-pay-pwd.vue?vue&type=style&index=0&id=5533ba13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5533ba13",
  null
  
)

export default component.exports